import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AvatarFromNameComponent } from './avatar-from-name.component.js';
import { AvatarModule as SourceAvatarModule } from 'ngx-avatars';

@NgModule({
	declarations: [AvatarFromNameComponent],
	exports: [AvatarFromNameComponent],
	imports: [CommonModule, SourceAvatarModule],
	providers: []
})
export class AvatarModule {}
